import React from 'react';
import { EstadoPedidoNuevo } from '../types/pedidosNuevos';
import {
  Clock,
  Send,
  ChefHat,
  CheckCircle,
  Truck,
  XCircle,
} from 'lucide-react';

interface EstadoBadgeProps {
  estado: EstadoPedidoNuevo;
  showIcon?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

/**
 * Badge para mostrar el estado de un pedido con colores y iconos
 */
const EstadoBadge: React.FC<EstadoBadgeProps> = ({
  estado,
  showIcon = true,
  size = 'md',
}) => {
  // Configuración de estilos por estado
  const configuracion: Record<
    EstadoPedidoNuevo,
    {
      color: string;
      icono: React.ElementType;
      texto: string;
    }
  > = {
    borrador: {
      color: 'bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-300',
      icono: Clock,
      texto: 'Borrador',
    },
    solicitado: {
      color: 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400',
      icono: Send,
      texto: 'Solicitado',
    },
    en_preparacion: {
      color:
        'bg-yellow-100 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-400',
      icono: ChefHat,
      texto: 'En Cocina',
    },
    listo: {
      color:
        'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400',
      icono: CheckCircle,
      texto: 'Listo',
    },
    despachado: {
      color:
        'bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-400',
      icono: Truck,
      texto: 'Despachado',
    },
    cancelado: {
      color: 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400',
      icono: XCircle,
      texto: 'Cancelado',
    },
  };

  const config = configuracion[estado] || configuracion.borrador;
  const Icon = config.icono;

  // Tamaños
  const tamaños = {
    sm: {
      badge: 'px-2 py-0.5 text-xs',
      icon: 'w-3 h-3',
    },
    md: {
      badge: 'px-2.5 py-1 text-sm',
      icon: 'w-4 h-4',
    },
    lg: {
      badge: 'px-3 py-1.5 text-base',
      icon: 'w-5 h-5',
    },
  };

  const tamaño = tamaños[size];

  return (
    <span
      className={`
        inline-flex items-center gap-1.5 rounded-full font-medium
        ${config.color}
        ${tamaño.badge}
      `}
    >
      {showIcon && <Icon className={tamaño.icon} />}
      <span>{config.texto}</span>
    </span>
  );
};

export default EstadoBadge;
